import { useState } from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { BlogDescription, BloggedPlaces, Footer, Navbar } from "../../shared/components";

function BlogsDescriptionPage() {
  const [countryId, setCountryId] = useState<string | null>(null);

  return (
    <Box backgroundColor="#FFFFFF" overflow="hidden">
      <Navbar />

      <Flex flexDirection="column" alignItems="center" marginTop="35px">
        <Flex alignSelf="flex-start">
          <Box marginLeft={{ base: "38px", md: "80px", lg: "100px", xl: "130px" }}>
            <Text
              as="b"
              sx={{ textTransform: "uppercase" }}
              fontSize={{ base: "15px" }}
              fontFamily="Lato, arial, sans-serif"
              color="black"
            >
              my blog
            </Text>
          </Box>
        </Flex>

        <Box width="80%" height="1px" bg="black" />

        <Flex flexDirection={{ base: "column", md: "row" }} alignItems="center">
          <Box
            marginTop={{ base: "10px", md: "0" }}
            marginRight={{ md: "150px", lg: "346px", xl: "618px", "2xl": "-90px" }}
            marginLeft={{ "2xl": "100px", base: "5px" }}
          >
            <Text fontSize={{ base: "9.5px", md: "15px", xl: "15px", "2xl": "18px" }}>
              Explore in-depth itineraries and guides for your most desired countries
            </Text>
          </Box>
          <Box marginTop={{ base: "20px", md: "22px" }} marginLeft={{ base: "0", md: "80px", lg: "100px", xl: "150px" }}>
            <BloggedPlaces onChange={countryId => setCountryId(countryId)} />
          </Box>
        </Flex>

        <Box width="100%" marginTop="10px" paddingX={{ base: "20px", md: "0" }} marginLeft={"30px"}>
          <BlogDescription countryId={countryId} />
        </Box>
      </Flex>

      <Footer />
    </Box>
  );
}

export default BlogsDescriptionPage;
